import { List } from 'immutable';

export const middleware = List([]);
